// Who may open the console is decided by the server: report-api's moderator list, asked through GET /me.
// ALLOWED_USERNAMES in the console is only a first filter; anyone can edit a bundle.
import { fetchWithAuth } from './auth';
import { getReportApiBaseUrl } from '../config/api';

export type ConsoleAccess = 'allowed' | 'denied' | 'unknown';

// 'denied' only on the server's explicit answer (403 MODERATOR_REQUIRED). A network error, a server error or an
// expired token decides nothing, so the caller chooses: login refuses, a running session stays.
const accessFrom = async (res: Response): Promise<ConsoleAccess> => {
  if (res.ok) return 'allowed';
  if (res.status === 403) {
    try {
      if ((await res.clone().json())?.code === 'MODERATOR_REQUIRED') return 'denied';
    } catch {
      // not JSON: not the gate's answer
    }
  }
  return 'unknown';
};

// At login, with the token just issued and before it is stored.
export const checkAccessWithToken = async (reportApiBaseUrl: string, token: string): Promise<ConsoleAccess> => {
  try {
    return await accessFrom(await fetch(`${reportApiBaseUrl}/me`, { headers: { Authorization: token } }));
  } catch {
    return 'unknown';
  }
};

// On start, with the stored session: fetchWithAuth refreshes an expired token first.
export const checkConsoleAccess = async (): Promise<ConsoleAccess> => {
  try {
    return await accessFrom(await fetchWithAuth(`${getReportApiBaseUrl()}/me`));
  } catch {
    return 'unknown';
  }
};
